import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import SimpleDataTable from "./SimpleDataTable";

const ConstraintWrapper = styled.div`
  min-width: 0;
  width: 100%;
`;

/**
 * DataGrid - Wrapper component for displaying file preview data.
 * Provides proper layout constraints for the data table in flex/grid contexts.
 */
const DataGrid = ({ loading, data, setHeader, canSetHeader }) => {
  return (
    <ConstraintWrapper>
      <SimpleDataTable
        loading={loading}
        data={data}
        setHeader={setHeader}
        canSetHeader={canSetHeader}
      />
    </ConstraintWrapper>
  );
};

DataGrid.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  setHeader: PropTypes.func,
  canSetHeader: PropTypes.bool,
};

export default DataGrid;
